import React from 'react';
import styled from 'styled-components';

interface ButtonRoundProps {
  uppercase?: boolean;
  inverted?: boolean;
  onClick(): void;
  disabled?: boolean;
}

export const Button = styled.button<ButtonRoundProps>`
  background-color: ${({theme, inverted}) =>
    inverted ? theme.color.white : theme.color.orange};
  border: none;
  border-radius: 50%;
  box-shadow: 2px 2px 10px 0px #ddd;
  color: ${({theme, inverted}) =>
    inverted ? theme.color.orange : theme.color.white};
  cursor: pointer;
  display: block;
  font-size: 3rem;
  height: 6rem;
  line-height: 2;
  margin-bottom: 6rem;
  padding: 0;
  position: relative;
  transition: all 0.3s ease-out;
  width: 6rem;

  span {
    -webkit-font-smoothing: subpixel-antialiased;
    bottom: -4rem;
    color: ${({theme}) => theme.color.black};
    display: block;
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 1.2;
    position: absolute;
  }

  &:hover {
    background-color: #cf4314;
    color: white;
  }

  &.disabled {
    background: ${({theme}) => theme.color.white};
    color: ${({theme}) => theme.color.gray};
    pointer-events: none;

    span {
      color: ${({theme}) => theme.color.gray};
    }
  }
`;

export const ButtonRound: React.SFC<ButtonRoundProps> = ({
  children,
  disabled,
  ...props
}) => {
  return (
    <Button className={disabled ? 'disabled' : ''} {...props}>
      {children}
    </Button>
  );
};
